import { GridColDef, GridRenderCellParams, GridRowParams } from '@mui/x-data-grid-premium';
import { dateTimeCell } from 'components/cells';
import {
  dateFilterOperators,
  filterOperators,
  singleSelectFilterOperators
} from 'components/enhanced';
import { ProductWarehouseHistorySource } from 'features/inventory/products/constants';
import { productWarehouseHistoryService } from 'features/inventory/warehouses/api/product-warehouse-history.service';
import HistoryDateTimeUpdateDialog from 'features/settings/history/components/HistoryDateTimeUpdateDialog';
import { useTranslation } from 'react-i18next';
import toast from 'shared/utils/toast';

export const WarehouseProductsHistoryLineColumns = (refresh: any): GridColDef[] => {
  const translationPrefix = 'pages.history.columns.content_type_name';
  const sourceTranslationPrefix = 'pages.history.columns.source';

  const { t } = useTranslation();
  const contentTypeOptions = Object.values(ProductWarehouseHistorySource).map((value) => ({
    value,
    label: t(`${sourceTranslationPrefix}.${value}`)
  }));

  const handleDateTimeUpdate = (id: number, datetime: string) => {
    productWarehouseHistoryService.update(id, { timestamp: datetime }).then(() => {
      toast.success(t('actions.successfully.updated'));
      if (refresh.current) {
        refresh.current();
      }
    });
  };

  const columns: GridColDef[] = [
    {
      field: 'timestamp',
      headerName: t(`${translationPrefix}.timestamp`),
      width: 200,
      filterOperators: dateFilterOperators,
      renderCell: dateTimeCell
    },
    {
      field: 'content_type_name',
      headerName: t(`${translationPrefix}.label`),
      width: 150,
      type: 'singleSelect',
      valueOptions: contentTypeOptions,
      filterOperators: singleSelectFilterOperators,
      renderCell: (params: GridRenderCellParams) => {
        return <div>{t(`${sourceTranslationPrefix}.${params.value}`)}</div>;
      }
    },
    {
      field: 'content_object_repr',
      filterOperators,
      width: 300,
      headerName: t(`${translationPrefix}.content_object_repr`)
    },
    {
      field: 'action_display',
      filterable: false,
      width: 150,
      headerName: t(`${translationPrefix}.action_display`),
      renderCell: (params: GridRenderCellParams) => {
        const source = params.row;
        return <div>{t(`${translationPrefix}.${source.action_display}`)}</div>;
      }
    },
    {
      field: 'entity_type',
      filterOperators,
      width: 250,
      headerName: t(`global.type`),
      renderCell: (params: GridRenderCellParams) => {
        const source = params.row;
        return <div>{t(`${translationPrefix}.entity_type.${source.entity_type}`)}</div>;
      }
    },
    {
      field: 'entity_code',
      filterOperators,
      width: 250,
      headerName: t(`global.entity_code`)
    },
    {
      field: 'warehouse_code',
      filterOperators,
      width: 250,
      headerName: t(`global.warehouse`)
    },
    {
      field: 'actions',
      type: 'actions',
      headerName: t(`global.actions`),
      getActions: (params: GridRowParams) => {
        const actions = [];
        actions.push(
          <HistoryDateTimeUpdateDialog
            key={980}
            id={params.row['id']}
            handleUpdate={handleDateTimeUpdate}
          />
        );
        return actions;
      }
    } as GridColDef
  ];

  return columns;
};
